<template>
  <transition :name="'page-chapter-' + direction" mode="out-in">
    <v-container class="home-page-chapter px-0 pl-md-12 mt-12 mt-md-0" fluid :class="{'home-page-chapter--coming-soon': chapter.comingSoon }" :key="index">
        <!-- :gradient="'to bottom, rgba(0, 0, 0, 0.' + ((chapter.comingSoon) ? '7' : '2') + '), #0e0e0e'" -->
      <seo-v-img
        :height="imageHeight"
        width="100%"
        :src="'/media/' + heroImage"
        class="background-img"
      />
      <v-row class="fill-height">
        <v-col cols="12" class="mt-n12 pl-12 z-index-2" align-self="end">
          <v-row>
            <v-col class="pl-0 pl-md-8" cols="8" sm="6" lg="4">
              <ChapterIndex :value="index.toString()" />
              <h2>{{current.title}}</h2>
              <a v-if="chapter.comingSoon" target="_blank" :href="$language.current === 'it' ? 'https://landing.mailerlite.com/webforms/landing/z3c3t0' : 'https://landing.mailerlite.com/webforms/landing/j1p4d8'">
                <TextCta disabled copy="Coming Soon" class="d-block mt-4 mb-12" />
              </a>
              <router-link class="d-block mt-4 mb-sm-12" :to="{ name: 'Chapter', params: { chapterId: index, chapterSlug: current._slug }}" v-else>
                <TextCta :copy="$root.siteSettings.genericExploreText" @click.native.stop.prevent="onExploreClick({ name: 'Chapter', params: { chapterId: index, chapterSlug: current._slug }})" />
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </transition>
</template>

<script>
import TextCta from '@/atoms/TextCta'
import ChapterIndex from '@/atoms/ChapterIndex'

import find from 'lodash/find'

export default {
  name: 'HomePageChapter',

  props: {
    data: {
      type: Array,
      required: true
    },

    index: {
      type: Number,
      required: true
    },

    direction: {
      type: String,
      required: true
    }
  },

  components: {
    TextCta,
    ChapterIndex
  },

  methods: {
    onExploreClick (to) {
      const from = this.$route
      this.$router.push(to)
      this.$events.emit('set-project-contents-open', { from })
    }
  },

  computed: {
    chapter () {
      const chapter = find(this.data, { _slug: 'chapter-' + this.index.toString() })
      return chapter
    },

    heroImage () {
      let id = this.chapter.heroImage.id
      if (this.chapter.heroImageArray && this.chapter.heroImageArray.length > 0) {
        const randid = Math.floor(Math.random() * this.chapter.heroImageArray.length)
        id = this.chapter.heroImageArray[randid].id
      }
      return id
    },

    current () {
      return (!this.chapter) ? {} : this.chapter[this.$route.params.language]
    },

    imageHeight () {
      let height = '50%'

      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          height = '50%'
          break
        case 'sm':
          height = '50%'
          break
        case 'md':
          height = '100%'
          break
        case 'lg':
          height = '100%'
          break
        case 'xl':
          height = '100%'
          break
      }

      return height
    }
  }
}
</script>

<style scoped lang="scss">

.home-page-chapter {
  position: relative;
  overflow: hidden;
  z-index: 0;

  &--coming-soon {
    h2,
    h4 {
      color: #404040;
    }

    h4::before {
      border-color: #404040;
    }
  }
}

.background-img {
  position: absolute;

  top: 15px;
  left: 0;

  animation: kenburns-top-left 15s ease-out both 0.5s;

  //Media_Query per escludere l'animazione solo per ie11
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    animation: none;
  }

  @include breakpoint('md-and-up') {
    top: 0;
  }
}

.page-chapter-next-enter-active,
.page-chapter-next-leave-active {
  transition: opacity 0.5s, transform 0.5s ease-out;
}

.page-chapter-next-enter {
  opacity: 0;
  transform: translateX(100%);
}

.page-chapter-next-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.page-chapter-prev-enter-active,
.page-chapter-prev-leave-active {
  transition: opacity 0.5s, transform 0.5s ease-out;
}

.page-chapter-prev-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.page-chapter-prev-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

</style>
